import { get, post, patch, putGeneric, deleteGeneric } from "../common/constants"

export default async function baseQuery({ url, data, type = "POST", headers }) {
    // Forward custom headers (e.g. X-Approval-Token for OTP-gated allocation
    // publish) to axios. Endpoints that don't set headers pass undefined, which
    // axios ignores — fully backward compatible.
    const config = headers ? { headers } : undefined
    try {
        switch (type) {
            case "POST":
                return await post(url, data, config)
            case "PATCH":
                return await patch(url, data, config)
            case "PUT":
                return await putGeneric(url, data)
            case "DELETE":
                return await deleteGeneric(url, data)
            default:
                return await get(url, data)
        }
    } catch (err) {
        throw err
    }
}